
import {Component, Prop} from "vue-property-decorator";
import {
    HCCValidator,
    HcPageModel,
    IHCCRule,
    IHCCValidator,
    PhoneNumberCzRule,
    PhoneNumberSkRule
} from "@dev/hc-components";
import HcAddress from "./HcAddress.vue";
import IEntrepreneur from "@/module/main/model/applicationForm/IEntrepreneur";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";
import Culture from "@/module/main/page/CultureEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";

@Component({
    components: {
        HcAddress
    }
})
export default class Entrepreneur extends HcPageModel
{
    @Prop({type: Object}) public value!: IEntrepreneur;
    @Prop({type: String}) public culture!: Culture;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "entrepreneur";
    private phoneNumberValidator: IHCCValidator = this.getPhoneNumberValidator();

    private get isOperatingLease(): boolean
    {
        return this.$store.getters["main/getOrderType"] === OrderType.OPERATING_LEASE;
    }

    private getPhoneNumberValidator(): IHCCValidator
    {
        return new HCCValidator(
            this.getPhoneNumberRules(),
            this.$localize("pg-phone-number-format-error-msg"),
            false,
            false
        );
    }

    private getPhoneNumberRules(): IHCCRule[]
    {
        return this.template === TemplateOptions.SK
            ? [new PhoneNumberSkRule(this.$localize("mobile-phone-format-error-msg"))]
            : [new PhoneNumberCzRule(this.$localize("mobile-phone-format-error-msg"))];
    }
}
